import { css } from 'styled-components';

export const notTouch = css`@media (hover: hover) and (pointer: fine)`;
